/**
 * Gold price data - exactly matching the original website
 */

export const getGoldPriceData = (currentTime) => [
  // TPHCM
  { 
    region: 'TPHCM', 
    type: 'PNJ', 
    buy: '111.200', 
    sell: '113.800', 
    time: currentTime, 
    regionSpan: 2, 
    typeClass: 'pnj-gold' 
  },
  { 
    region: '', 
    type: 'SJC', 
    buy: '116.000', 
    sell: '118.000', 
    time: currentTime, 
    regionSpan: 0, 
    typeClass: 'sjc-gold' 
  },
  
  // Hà Nội
  { 
    region: 'Hà Nội', 
    type: 'PNJ', 
    buy: '111.200', 
    sell: '113.800', 
    time: currentTime, 
    regionSpan: 2, 
    typeClass: 'pnj-gold' 
  },
  { 
    region: '', 
    type: 'SJC', 
    buy: '116.000', 
    sell: '118.000', 
    time: currentTime, 
    regionSpan: 0, 
    typeClass: 'sjc-gold' 
  },
  
  // Đà Nẵng
  { 
    region: 'Đà Nẵng', 
    type: 'PNJ', 
    buy: '111.200', 
    sell: '113.800', 
    time: currentTime, 
    regionSpan: 2, 
    typeClass: 'pnj-gold' 
  },
  { 
    region: '', 
    type: 'SJC', 
    buy: '116.000', 
    sell: '118.000', 
    time: currentTime, 
    regionSpan: 0, 
    typeClass: 'sjc-gold' 
  },
  
  // Miền Tây
  { 
    region: 'Miền Tây', 
    type: 'PNJ', 
    buy: '111.200', 
    sell: '113.800', 
    time: currentTime, 
    regionSpan: 2, 
    typeClass: 'pnj-gold' 
  },
  { 
    region: '', 
    type: 'SJC', 
    buy: '116.000', 
    sell: '118.000', 
    time: currentTime, 
    regionSpan: 0, 
    typeClass: 'sjc-gold' 
  },
  
  // Tây Nguyên
  { 
    region: 'Tây Nguyên', 
    type: 'PNJ', 
    buy: '111.200', 
    sell: '113.800', 
    time: currentTime, 
    regionSpan: 2, 
    typeClass: 'pnj-gold' 
  },
  { 
    region: '', 
    type: 'SJC', 
    buy: '116.000', 
    sell: '118.000', 
    time: currentTime, 
    regionSpan: 0, 
    typeClass: 'sjc-gold' 
  },
  
  // Đông Nam Bộ
  { 
    region: 'Đông Nam Bộ', 
    type: 'PNJ', 
    buy: '111.200', 
    sell: '113.800', 
    time: currentTime, 
    regionSpan: 2, 
    typeClass: 'pnj-gold' 
  },
  { 
    region: '', 
    type: 'SJC', 
    buy: '116.000', 
    sell: '118.000', 
    time: currentTime, 
    regionSpan: 0, 
    typeClass: 'sjc-gold' 
  },
  
  // Giá vàng nữ trang
  { 
    region: 'Giá vàng nữ trang', 
    type: 'Nhẫn Trơn PNJ 999.9', 
    buy: '111.200', 
    sell: '113.800', 
    time: currentTime, 
    regionSpan: 16, 
    typeClass: 'pnj-gold' 
  },
  { 
    region: '', 
    type: 'Vàng Kim Bảo 999.9', 
    buy: '111.200', 
    sell: '113.800', 
    time: currentTime, 
    regionSpan: 0, 
    typeClass: 'sjc-gold' 
  },
  { 
    region: '', 
    type: 'Vàng Phúc Lộc Tài 999.9', 
    buy: '111.200', 
    sell: '113.800', 
    time: currentTime, 
    regionSpan: 0, 
    typeClass: 'pnj-gold' 
  },
  { 
    region: '', 
    type: 'Vàng nữ trang 999.9', 
    buy: '110.700', 
    sell: '113.200', 
    time: currentTime, 
    regionSpan: 0, 
    typeClass: 'sjc-gold' 
  },
  { 
    region: '', 
    type: 'Vàng nữ trang 999', 
    buy: '110.590', 
    sell: '113.090', 
    time: currentTime, 
    regionSpan: 0, 
    typeClass: 'pnj-gold' 
  },
  { 
    region: '', 
    type: 'Vàng nữ trang 9920', 
    buy: '109.890', 
    sell: '112.390', 
    time: currentTime, 
    regionSpan: 0, 
    typeClass: 'sjc-gold' 
  },
  { 
    region: '', 
    type: 'Vàng nữ trang 99', 
    buy: '109.670', 
    sell: '112.170', 
    time: currentTime, 
    regionSpan: 0, 
    typeClass: 'pnj-gold' 
  },
  { 
    region: '', 
    type: 'Vàng 750 (18K)', 
    buy: '77.550', 
    sell: '85.050', 
    time: currentTime, 
    regionSpan: 0, 
    typeClass: 'sjc-gold' 
  },
  { 
    region: '', 
    type: 'Vàng 585 (14K)', 
    buy: '58.870', 
    sell: '66.370', 
    time: currentTime, 
    regionSpan: 0, 
    typeClass: 'pnj-gold' 
  },
  { 
    region: '', 
    type: 'Vàng 416 (10K)', 
    buy: '39.740', 
    sell: '47.240', 
    time: currentTime, 
    regionSpan: 0, 
    typeClass: 'sjc-gold' 
  },
  { 
    region: '', 
    type: 'Vàng 916 (22K)', 
    buy: '101.290', 
    sell: '103.790', 
    time: currentTime, 
    regionSpan: 0, 
    typeClass: 'pnj-gold' 
  },
  { 
    region: '', 
    type: 'Vàng 610 (14.6K)', 
    buy: '61.700', 
    sell: '69.200', 
    time: currentTime, 
    regionSpan: 0, 
    typeClass: 'sjc-gold' 
  },
  { 
    region: '', 
    type: 'Vàng 650 (15.6K)', 
    buy: '66.230', 
    sell: '73.730', 
    time: currentTime, 
    regionSpan: 0, 
    typeClass: 'pnj-gold' 
  },
  { 
    region: '', 
    type: 'Vàng 680 (16.3K)', 
    buy: '69.630', 
    sell: '77.130', 
    time: currentTime, 
    regionSpan: 0, 
    typeClass: 'sjc-gold' 
  },
  { 
    region: '', 
    type: 'Vàng 375 (9K)', 
    buy: '35.100', 
    sell: '42.600', 
    time: currentTime, 
    regionSpan: 0, 
    typeClass: 'pnj-gold' 
  },
  { 
    region: '', 
    type: 'Vàng 333 (8K)', 
    buy: '30.010', 
    sell: '37.510', 
    time: currentTime, 
    regionSpan: 0, 
    typeClass: 'sjc-gold' 
  }
];

export const emptyHistoryGoldData = [
  {
    name: "TPHCM"
  },
  {
    name: "Hà Nội"
  },
  {
    name: "Đà Nẵng"
  },
  {
    name: "Miền Tây"
  },
  {
    name: "Tây Nguyên"
  },
  {
    name: "Đông Nam Bộ"
  },
  {
    name: "Giá vàng nữ trang"
  }
];

export const productCategories = [
  {
    href: "https://cao.com.vn/",
    imageSrc: "/images/cao-brand.jpg",
    title: "CAO"
  },
  {
    href: "https://www.pnj.com.vn/trang-suc-kim-cuong/",
    imageSrc: "/images/diamond.jpg",
    title: "Trang sức kim cương"
  },
  {
    href: "https://www.pnj.com.vn/trang-suc-da-quy/",
    imageSrc: "/images/gemstone.jpg",
    title: "Trang sức đá quý"
  },
  {
    href: "https://www.pnj.com.vn/trang-suc-cuoi/",
    imageSrc: "/images/wedding.png",
    title: "Trang sức cưới"
  },
  {
    href: "https://www.pnj.com.vn/trang-suc-vang/",
    imageSrc: "/images/gold.png",
    title: "Trang sức vàng"
  },
  {
    href: "https://www.pnj.com.vn/qt-doanh-nghiep/",
    imageSrc: "/images/corporate-gift.png",
    title: "Quà tặng doanh nghiệp"
  }
]; 